import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@ninety/ui/web/environments';

const apiRegex = /^\/?api\/v4/i;
const mazApiRegex = /^\/?api\/maz\/v1/i;
const internalApiRegex = /^\/?(?:api\/internal|eks)(?:\/|$)/i;
const trailingSlashRegex = /\/$|\/(?=\?)|\/(?=#)/;

export function HostInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const path = req.url;
  let newOrigin = '';
  let withCredentials = false;
  if (environment.apiOrigin && apiRegex.test(path)) {
    newOrigin = environment.apiOrigin;
    withCredentials = true;
  } else if (environment.mazApiOrigin && mazApiRegex.test(path)) {
    newOrigin = environment.mazApiOrigin;
    withCredentials = true;
  } else if (environment.apiOrigin && internalApiRegex.test(path)) {
    newOrigin = environment.apiOrigin;
    withCredentials = true;
  }

  if (newOrigin) {
    const newUrl = new URL(path, newOrigin);
    const normalizedUrl = newUrl.toString().replace(trailingSlashRegex, '');
    req = req.clone({ url: normalizedUrl, ...(withCredentials ? { withCredentials } : {}) });
  }

  return next(req);
}
